// Detect whether a session is ranked by best lap (practice/qualy) or by
// race position (laps DESC, total time ASC). Default: race.

const BEST_LAP_KEYWORDS = [
  'practice', 'free practice', 'official practice', 'unofficial practice',
  'warm up', 'warmup', 'warm up session', 'qualifying', 'qualification',
  'single car qualifying', 'group qualifying', 'pre qualifying', 'time trial',
  'superpole', 'super pole', 'qualifying practice', 'combined qualifying',
  // Español
  'entrenamiento', 'entrenamientos', 'practica', 'practicas', 'prueba', 'pruebas',
  'ensayo', 'ensayos', 'tanda', 'tandas', 'clasificacion', 'clasificaciones',
  'pre clasificacion', 'prueba libre', 'pruebas libres', 'contrarreloj',
];

const RACE_KEYWORDS = [
  'race', 'heat', 'series', 'pre final', 'prefinal', 'semi final', 'semifinal',
  'final', 'grand final', 'super final', 'superfinal', 'sprint race', 'feature race',
  'a main', 'b main', 'consolation final', 'super heat',
  // Español
  'carrera', 'carreras', 'serie', 'gran final', 'carrera sprint', 'manga', 'mangas',
  'repechaje', 'super serie',
];

const normalize = (s) => ` ${String(s || '')
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[^a-z0-9]+/g, ' ')
  .replace(/([a-z])(\d)/g, '$1 $2')
  .trim()} `;

const matches = (norm, list) => list.some((kw) => norm.includes(` ${kw} `));

// Returns 'best_lap' | 'race' | null (null = no keyword found).
export const classifySessionName = (name) => {
  const norm = normalize(name);
  if (matches(norm, BEST_LAP_KEYWORDS)) return 'best_lap';
  if (matches(norm, RACE_KEYWORDS)) return 'race';
  return null;
};

// Session name first (most specific), then the full race name. Default race.
export const detectSessionType = (race) => {
  for (const n of [race?.speedhive_session_name, race?.name]) {
    const t = n ? classifySessionName(n) : null;
    if (t) return t;
  }
  return 'race';
};
